module.exports = __webpack_public_path__ + "static/quotationPopup-22699a28c888f23bce88e125f3b78cfd.gif";